import {ensureString, formatDateBr, toISODate} from "../../../utils/convert-fields"

const cpfCnpjInputProps = {inputMode: "numeric", pattern: "[0-9]*", maxLength: 18}

const dateMask = "99/99/9999"
export const ratingFields = [
    {
        key: "DataReferencia",
        label: "Data Referência",
        md: 4,
        defaultValue: null,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
    },
    {
        key: "DataValidade",
        label: "Data Validade",
        md: 4,
        defaultValue: null,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
    },
    {
        key: "CPFCNPJ",
        label: "CPF / CNPJ",
        md: 4,
        defaultValue: null,
        inputProps: cpfCnpjInputProps,
        maskType: "cpfCnpj"
    },
    {key: "Fonte", label: "Fonte", md: 4, defaultValue: null},
    {key: "ScoreRating", label: "Score Rating", md: 4, defaultValue: null},
    {key: "Rating", label: "Rating", md: 4, defaultValue: null},
    {key: "Sinal", label: "Sinal", md: 4, defaultValue: null},
    {key: "Perspectiva", label: "Perspectiva", md: 4, defaultValue: null},
    {key: "Observacao", label: "Observação", md: 4, defaultValue: null},
    {
        key: "AnaliseCreditoEmissao",
        label: "Análise Resumo Crédito",
        md: 12,
        defaultValue: "Emissão clean com risco remetendo à qualidade creditícia do devedor."
    },
]

export const mapRatingEmissao = (ratingEmissao) => {
    return {
        "ID": ratingEmissao.ID,
        "DataReferencia": formatDateBr(ratingEmissao.DataReferencia),
        "DataValidade": formatDateBr(ratingEmissao.DataValidade),
        "CPFCNPJ": ensureString(ratingEmissao.CPFCNPJ),
        "Fonte": ensureString(ratingEmissao.Fonte),
        "ScoreRating": ensureString(ratingEmissao.ScoreRating),
        "Rating": ensureString(ratingEmissao.Rating),
        "Sinal": ensureString(ratingEmissao.Sinal),
        "Perspectiva": ensureString(ratingEmissao.Perspectiva),
        "Observacao": ensureString(ratingEmissao.Observacao),
        "AnaliseCreditoEmissao": ensureString(ratingEmissao.AnaliseCreditoEmissao)
    }
}

export const mapPayloadRatingEmissao = (cetip, ratingEmissao) => {
    return {
        "CETIP": cetip.toUpperCase(),
        "DataReferencia": toISODate(ratingEmissao.DataReferencia),
        "DataValidade": toISODate(ratingEmissao.DataValidade),
        "CPFCNPJ": ensureString(ratingEmissao.CPFCNPJ),
        "Fonte": ensureString(ratingEmissao.Fonte),
        "ScoreRating": ensureString(ratingEmissao.ScoreRating),
        "Rating": ensureString(ratingEmissao.Rating),
        "Sinal": ensureString(ratingEmissao.Sinal) || null,
        "Vencimento": toISODate(ratingEmissao.Vencimento) || null,
        "Perspectiva": ensureString(ratingEmissao.Perspectiva),
        "Observacao": ensureString(ratingEmissao.Observacao) || null,
        "AnaliseCreditoEmissao": ensureString(ratingEmissao.AnaliseCreditoEmissao) || "Emissão clean com risco remetendo à qualidade creditícia do devedor."
    }
}